// Previously this was like:
// import { ITranslationKeys, ITranslations } from '@interfaces';
// but I don't think it is a good way to type all of the translation keys
// for now just allow to pass any string to translaiton service
type ITranslationKeys = string;
type ITranslations = Record<string, string>;

export class TranslationService {
    private static translations: ITranslations = {};

    private static requestQueue: ITranslationKeys[] = [];

    public static registerKeys(newKeys: ITranslationKeys[]) {
        this.requestQueue = [...this.requestQueue, ...newKeys];
        this.deDuplicateQueue();
    }

    public static translate(key: ITranslationKeys): string {
        if (
            (this.translations[key] || typeof this.translations[key] === 'string') &&
            this.translations[key] !== ''
        ) {
            return this.translations[key] as string;
        } else {
            this.registerKeys([key]);
        }
        return key;
    }
    private static deDuplicateQueue(): void {
        this.requestQueue = this.requestQueue.filter(
            (key, index) => this.requestQueue.indexOf(key) === index,
        );
    }
    private static getUntranslatedStrings(): ITranslationKeys[] {
        return this.requestQueue.filter(
            (key) => !(key in this.translations && this.translations[key]),
        );
    }

    public static getQueue(): string[] {
        return this.getUntranslatedStrings();
    }

    public static update(translations: ITranslations) {
        this.translations = { ...this.translations, ...translations };
        this.requestQueue = this.getUntranslatedStrings();
    }
}

export const __ = (key: ITranslationKeys) => TranslationService.translate(key);
